import React from 'react';
import { WrappedButton, WrappedButtonType } from '../../ui/button';
import Link from '../../ui/Link.component';
import InlineMessage from '../../ui/panel/InlineMessage.component';

const BANNER_CONFIG = {
	warning: {
		header: 'Connect your USPS Business Account',
		text: 'You need to connect your USPS Business Account to Stamps.com to access your special NSA rates. Please check the guidelines for a successful connection.',
		linkText: 'Learn more about USPS Business Accounts',
		canClose: false,
		dataqa: 'usps-business-connect-message',
	},
	information: {
		header: 'USPS Business Account approval pending',
		text: 'Please contact your USPS sales representative to ensure your EPA and contract are linked.',
		linkText: 'Learn more about USPS Business Accounts',
		canClose: true,
		dataqa: 'usps-business-approval-message',
	},
};

const UspsBusinessBanner = ({
	type = 'warning',
	onClose,
	onCheckGuidelinesClick,
	onLearnMoreClick,
}) => {
	const { header, text, linkText, canClose, dataqa } =
		BANNER_CONFIG[type] || BANNER_CONFIG.warning;

	const actions = (
		<div className="usps-business-banner-actions">
			{onCheckGuidelinesClick && (
				<WrappedButton
					label="See Guidelines"
					buttonType={WrappedButtonType.TertiaryWhite}
					dataqa={dataqa}
					onClick={onCheckGuidelinesClick}
				/>
			)}
			{/* Dev Note: The help articles are not yet available. Per Product, we are not displaying the learn more link temporarily.
				Uncomment this code when the help articles are availabl
			<Link className="link-with-icon" onClick={onLearnMoreClick} navIcon={true}>
				{linkText}
				<span className="external-link-icon" />
			</Link>*/}
		</div>
	);

	return (
		<div className="banner-container">
			<InlineMessage
				type={type}
				header={header}
				text={text}
				canClose={canClose && !!onClose}
				actions={actions}
				dataqa={dataqa}
				onClose={onClose}
			></InlineMessage>
		</div>
	);
};

export default UspsBusinessBanner;
